<template>
    <CustomDialog v-model="localVisible" width="500px">
        <template #title>
            <div class="ppv2-flex ppv2-items-center ppv2-justify-between ppv2-w-full">
                <span class="ppv2-text-lg poppinsSemiBold ppv2-text-black">
                    {{
                        isEditing
                            ? $t('staff_planning_v3.components.create_shift.title_edit')
                            : $t('staff_planning_v3.components.create_shift.title_create')
                    }}
                </span>
            </div>
        </template>

        <template #content>
            <div class="ppv2-space-y-4">
                <div>
                    <BaseInput
                        v-model="localForm.name"
                        :required="true"
                        :error="errors?.name?.[0]"
                        :label="$t('staff.external_resource.name')"
                    />
                </div>

                <div>
                    <BaseInput
                        v-model="localForm.email"
                        :required="true"
                        :error="errors?.email?.[0]"
                        :label="$t('staff.external_resource.email')"
                    />
                </div>
            </div>
        </template>

        <template #actions>
            <ModalActions @cancel="closeModal" @confirm="submit" :confirmLabel="$t('common.save')" />
        </template>
    </CustomDialog>
</template>

<script>
import CustomDialog from '../../../Shared/CustomDialog.vue'
import BaseInput from '../../../Shared/BaseInput.vue'
import ModalActions from './ModalActions.vue'

export default {
    name: 'ResourceExterneModal',

    components: {
        CustomDialog,
        BaseInput,
        ModalActions,
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        isEditing: {
            type: Boolean,
            default: false,
        },
        resourceForm: {
            type: Object,
            required: true,
            default: () => ({ name: '', email: '', uid: '' }),
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },

    emits: ['input', 'save'],

    data() {
        return {
            localForm: {
                name: '',
                email: '',
                uid: '',
                ...this.resourceForm,
            },
        }
    },

    computed: {
        localVisible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },

    watch: {
        // FIXED: Changed from absenceForm to resourceForm
        resourceForm: {
            deep: true,
            handler(newVal) {
                this.localForm = { ...newVal }
            },
        },
    },

    methods: {
        closeModal() {
            this.$emit('input', false)
        },

        // Generates a simple frontend unique ID if not using backend UUIDs
        generateUid() {
            return Math.random().toString(36).substr(2, 9) + '_' + Date.now()
        },

        submit() {
            // Generate a UID if it doesn't already exist (e.g., if creating vs editing)
            if (!this.localForm.uid) {
                this.localForm.uid = this.generateUid()
            }

            this.$emit('save', {
                ...this.localForm,
            })
        },
    },
}
</script>
